// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n  This template also provides the ability to use CSS modules for custom styling:\n*/\n.sc1_p44lt4XN1XOB3n1L {\n  font-family: 'Courier New', Courier, monospace;\n}\n", "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,8CAA8C;AAChD","sourcesContent":["/*\n  This template also provides the ability to use CSS modules for custom styling:\n*/\n.myCustomCssClass {\n  font-family: 'Courier New', Courier, monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"myCustomCssClass": "sc1_p44lt4XN1XOB3n1L"
};
export default ___CSS_LOADER_EXPORT___;
